import { memo } from 'react';
import css from './index.module.scss';
import classNames from 'classnames';
import { GMGenericButton } from '../ButtonBase';
import { GenericButtonProps } from '../ButtonBase/GenericButton/GenericButton.types';

type Theme = 'primary' | 'secondary';
interface AdminButtonProps extends GenericButtonProps {
    label: string;
    theme?: Theme;
}

export const AdminButton = memo(({
    label,
    id,
    ariaLabel,
    theme = 'primary',
    onClick,
}: AdminButtonProps) => (
    <GMGenericButton
        id={id}
        ariaLabel={ariaLabel}
        onClick={onClick}
    >
        <div className={classNames(css.adminButton, css[theme])}>
            {label}
        </div>
    </GMGenericButton>
));
